// not in use - refer to useStepper instead this
// src/hooks/checkout/useStepper

import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { setBookingStep } from '@/store/booking/booking.slice';
import { useRouter } from 'next/router';
import { useAddOns } from '@/store';

export const PATHS = {
  HOME: {
    name: 'HOME',
    path: '/',
    label: 'checkout.paths.home',
    icon: 'mdi:ticket-confirmation-outline',
  },
  AUTH: {
    name: 'AUTH',
    path: '/auth',
    label: 'checkout.paths.auth',
    icon: 'ph:user',
  },
  ADDONS: {
    name: 'ADDONS',
    path: '/addons',
    label: 'checkout.paths.addons',
    icon: 'ph:shield-plus',
  },
  CUSTOMIZATION: {
    name: 'CUSTOMIZATION',
    path: '/customization',
    label: 'checkout.paths.customization',
    icon: 'material-symbols:edit-outline-rounded',
  },
  PAYMENT: {
    name: 'PAYMENT',
    path: '/payment',
    label: 'checkout.paths.payment',
    icon: 'material-symbols:credit-card-outline',
  },
  SUCCESS: {
    name: 'SUCCESS',
    path: '/success',
    label: 'checkout.paths.success',
    icon: 'material-symbols:celebration',
  },
};

export const checkoutFlow = [
  PATHS.HOME,
  PATHS.AUTH,
  PATHS.CUSTOMIZATION,
  PATHS.PAYMENT,
  PATHS.SUCCESS,
];

export const checkoutFlowWithAddOns = [
  PATHS.HOME,
  PATHS.AUTH,
  PATHS.CUSTOMIZATION,
  PATHS.ADDONS,
  PATHS.PAYMENT,
  PATHS.SUCCESS,
];

export default function useCheckoutSteps() {
  const { addOnsActive } = useAddOns();

  const router = useRouter();

  const currentFlow =
    router.pathname === '/addons' || addOnsActive
      ? checkoutFlowWithAddOns
      : checkoutFlow;

  const flow = currentFlow.map((path) => path.path);

  const dispatch = useDispatch();
  const summary = useSelector((state) => state.summary, shallowEqual);

  const next = () => {
    let currentIndex = flow.indexOf(router.pathname) + 1;

    if (currentIndex < flow.length) {
      let nextStep = currentFlow[currentIndex].name;

      if (
        nextStep === PATHS.ADDONS.name &&
        summary.total_to_pay === 0 &&
        !addOnsActive
      ) {
        currentIndex += 1;
        nextStep = currentFlow[currentIndex].name;
      }

      router.push(flow[currentIndex]);
      if (nextStep !== PATHS.SUCCESS.name) {
        dispatch(setBookingStep(nextStep));
      }
    }
  };

  const success = async () => {
    if (router.pathname === '/success') {
      dispatch(setBookingStep(PATHS.SUCCESS.name));
    }
  };

  return {
    next,
    success,
  };
}
